return<template>
  <div class="message-wrap">
    <transition name="el-fade-in">
      <div class="message-box" v-show="isShowMessageBox">
        <h1 class="title">
          <span>{{ title }}</span>
          <i
            class="el-icon-error"
            @click="beforeClose"
            style="color:#CDCDCD;"
          ></i>
        </h1>
        <div class="message-content" v-if="isShowText">
          <p class="content-title">{{ tips }}</p>
          <p class="content">
            <i class="el-icon-info" style="color:#FC4849;"></i>
            {{ content }}
          </p>
        </div>
        <div class="message-input" v-if="isShowInput">
          <el-form
            :model="ruleForm"
            status-icon
            :rules="rules"
            ref="ruleForm"
            label-width="70px"
            class="demo-ruleForm"
          >
            <el-form-item label="密码" prop="pass">
              <el-input
                type="password"
                v-model="ruleForm.pass"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="checkPass">
              <el-input
                type="password"
                v-model="ruleForm.checkPass"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="message-button">
          <el-button type="primary" @click="confirm" v-if="isShowConfimrBtn">
            {{ confirmBtnText }}
          </el-button>
          <el-button
            type="primary"
            plain
            @click="cancel"
            v-if="isShowCancelBtn"
            >{{ cancelBtnText }}</el-button
          >
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '账号异常,请联系管理员'
    },
    tips: {
      type: String,
      default: '请联系管理员！'
    },
    content: {
      type: String,
      default: '确认要保存编辑的内容吗？'
    },
    isShowCancelBtn: {
      type: Boolean,
      default: true
    },
    isShowConfimrBtn: {
      type: Boolean,
      default: true
    },
    cancelBtnText: {
      type: String,
      default: '取消'
    },
    confirmBtnText: {
      type: String,
      default: '确定'
    },
    // 右上角的关闭是否和确认一样  默认否
    cancelTopisConfirm: {
      type: Boolean,
      default: false
    },
    isShowText: {
      type: Boolean,
      default: true
    },
    isShowInput: {
      type: Boolean,
      default: false
    }
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('请输入密码'));
      } else {
        if (this.ruleForm.checkPass !== '') {
          this.$refs.ruleForm.validateField('checkPass');
        }
        return callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('请再次输入密码'));
      } else if (value !== this.ruleForm.pass) {
        return callback(new Error('两次输入密码不一致!'));
      } else {
        return callback();
      }
    };

    return {
      isShowMessageBox: false,
      resolve: '',
      reject: '',
      promise: '', // 保存promise对象
      ruleForm: {
        pass: '',
        checkPass: ''
      },
      rules: {
        pass: [{ validator: validatePass, trigger: 'blur' }],
        checkPass: [{ validator: validatePass2, trigger: 'blur' }]
      }
    };
  },
  methods: {
    // 确定,将promise断定为resolve状态
    confirm: function() {
      if (this.isShowInput) {
        this.$refs['ruleForm'].validate(valid => {
          if (valid) {
            alert('submit!');
            this.isShowMessageBox = false;
            this.resolve();
            this.remove();
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      } else {
        this.isShowMessageBox = false;
        this.resolve('confirm');
        this.remove();
      }
    },
    // 取消,将promise断定为reject状态
    cancel: function() {
      this.isShowMessageBox = false;
      this.reject('cancel');
      this.remove();
    },
    // 右上角取消按钮操作逻辑
    // cancelTop() {
    //   if (this.cancelTopisConfirm) {
    //     this.confirm();
    //   } else {
    //     this.cancel();
    //   }
    // },
    // 右上角取消按钮操作逻辑
    beforeClose: function() {
      if (this.cancelTopisConfirm) {
        this.confirm();
      } else {
        this.isShowMessageBox = false;
        this.reject('close');
        this.remove();
      }
    },
    // 弹出messageBox,并创建promise对象
    showMsgBox: function() {
      this.isShowMessageBox = true;
      this.promise = new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
      // 返回promise对象
      return this.promise;
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          alert('submit!');
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    remove: function() {
      setTimeout(() => {
        this.destroy();
      }, 300);
    },
    destroy: function() {
      this.$destroy();
      document.body.removeChild(this.$el);
    }
  }
};
</script>
<style lang="scss" scoped>
.message-wrap {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
  overflow: hidden;
  .message-box {
    width: 450px;
    height: auto;
    position: absolute;
    background: #fff;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
    border-radius: 6px;
    padding: 20px;
    box-sizing: border-box;
    .title {
      position: relative;
      span {
        font-weight: 600;
        font-size: 18px;
      }
      i {
        position: absolute;
        right: -5px;
        top: -5px;
      }
    }
    .message-content {
      padding: 20px 0;
      .content-title {
        font-size: 16px;
        text-align: center;
      }
      .content {
        font-size: 16px;
        text-align: center;
        line-height: 25px;
        margin-bottom: 10px;
        i {
          display: inline-block;
          width: 16px;
          height: 16px;
          margin-right: 10px;
          position: relative;
          top: 1px;
        }
      }
    }
    .message-input {
      padding: 10px 38px;
    }
    .message-button {
      text-align: center;
    }
  }
}
</style>
